import script from "./AppNotifications.vue?vue&type=script&setup=true&lang=js"
export * from "./AppNotifications.vue?vue&type=script&setup=true&lang=js"

import "./AppNotifications.vue?vue&type=style&index=0&id=39512e54&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-39512e54"]])

export default __exports__